export const SAMPLE_DEMO_CLIENTS = [
  { name: 'Alex Morgan', email: 'alex.morgan@example.com', phone: '5550101001' },
  { name: 'Jordan Lee', email: 'jordan.lee@example.com', phone: '5550101002' },
  { name: 'Taylor Brooks', email: 'taylor.brooks@example.com', phone: '5550101003' },
  { name: 'Casey Rivera', email: 'casey.rivera@example.com', phone: '5550101004' },
  { name: 'Morgan Chen', email: 'morgan.chen@example.com', phone: '5550101005' },
  { name: 'Riley Patel', email: 'riley.patel@example.com', phone: '5550101006' },
  { name: 'Jamie Foster', email: 'jamie.foster@example.com', phone: '5550101007' },
  { name: 'Sam Nguyen', email: 'sam.nguyen@example.com', phone: '5550101008' },
  { name: 'Drew Collins', email: 'drew.collins@example.com', phone: '5550101009' },
  { name: 'Avery Kim', email: 'avery.kim@example.com', phone: '5550101010' },
  { name: 'Quinn Adams', email: 'quinn.adams@example.com', phone: '5550101011' },
  { name: 'Blake Turner', email: 'blake.turner@example.com', phone: '5550101012' },
  { name: 'Maria Santos', email: 'maria.santos@example.com', phone: '5550101013' },
  { name: 'James O\'Connor', email: 'james.oconnor@example.com', phone: '5550101014' },
  { name: 'Priya Sharma', email: 'priya.sharma@example.com', phone: '5550101015' },
  { name: 'Ethan Williams', email: 'ethan.williams@example.com', phone: '5550101016' },
  { name: 'Sofia Alvarez', email: 'sofia.alvarez@example.com', phone: '5550101017' },
  { name: 'Noah Thompson', email: 'noah.thompson@example.com', phone: '5550101018' },
  { name: 'Aisha Khan', email: 'aisha.khan@example.com', phone: '5550101019' },
  { name: 'Lucas Müller', email: 'lucas.muller@example.com', phone: '5550101020' },
  { name: 'Emily Nakamura', email: 'emily.nakamura@example.com', phone: '5550101021' },
  { name: 'Marcus Johnson', email: 'marcus.johnson@example.com', phone: '5550101022' },
  { name: 'Isabella Rossi', email: 'isabella.rossi@example.com', phone: '5550101023' },
  { name: 'Daniel Okonkwo', email: 'daniel.okonkwo@example.com', phone: '5550101024' },
  { name: 'Hannah Bergström', email: 'hannah.bergstrom@example.com', phone: '5550101025' },
  { name: 'Ryan Murphy', email: 'ryan.murphy@example.com', phone: '5550101026' },
  { name: 'Yuki Tanaka', email: 'yuki.tanaka@example.com', phone: '5550101027' },
  { name: 'Olivia Martinez', email: 'olivia.martinez@example.com', phone: '5550101028' },
  { name: 'Benjamin Clarke', email: 'benjamin.clarke@example.com', phone: '5550101029' },
  { name: 'Fatima Hassan', email: 'fatima.hassan@example.com', phone: '5550101030' },
  { name: 'Christopher Reed', email: 'christopher.reed@example.com', phone: '5550101031' },
  { name: 'Nina Petrov', email: 'nina.petrov@example.com', phone: '5550101032' },
  { name: 'David Kimura', email: 'david.kimura@example.com', phone: '5550101033' },
  { name: 'Grace Sullivan', email: 'grace.sullivan@example.com', phone: '5550101034' },
  { name: 'Ahmed El-Sayed', email: 'ahmed.elsayed@example.com', phone: '5550101035' },
  { name: 'Chloe Dubois', email: 'chloe.dubois@example.com', phone: '5550101036' },
  { name: 'Michael Zhang', email: 'michael.zhang@example.com', phone: '5550101037' },
  { name: 'Elena Popescu', email: 'elena.popescu@example.com', phone: '5550101038' },
  { name: 'William Fraser', email: 'william.fraser@example.com', phone: '5550101039' },
  { name: 'Mei Lin', email: 'mei.lin@example.com', phone: '5550101040' },
];
